import React, { useState, useEffect } from "react";
import { collection, addDoc, doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import Cierre from "../../Cierre";
import { useAuth } from "../../context/authContext";
import { useNavigate } from 'react-router-dom';
import { app } from "../../firebase";


function Form8() {
  const [archivos, setArchivos] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    // Función para obtener la lista de archivos almacenados en una carpeta específica de Firebase Storage
    const obtenerArchivos = async () => {
      
      const storageRef = app.storage().ref();
      const carpetaRef = storageRef.child(user.displayName + "/te1-convencional"); // Reemplaza 'tu/carpeta/especifica' con la ruta de tu carpeta
      const listaArchivos = await carpetaRef.listAll();
      const urlsPromesas = listaArchivos.items.map(item => item.getDownloadURL());
      const urls = await Promise.all(urlsPromesas);
      const archivosData = listaArchivos.items.map((item, index) => {
        return {
          nombre: item.name,
          url: urls[index]
        };
      });
      setArchivos(archivosData);
    };

    obtenerArchivos();
  }, []);

  return (
    <div className="flex-1 py-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-8">Tus TE-1 Convencionales.</h1>
        <div className="space-y-4">
          {archivos.map((archivo, index) => (
            <div key={index} className={`p-4 rounded-md bg-gray-${index % 2 === 0 ? '100' : '300'}`}>
              <a href={archivo.url} target="_blank" rel="noopener noreferrer" className="block w-full text-blue-500 hover:underline">{archivo.nombre}</a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


export default Form8;

